import Logo from './Logo';

const PoweredByFeedaura = ({ primaryColor }: { primaryColor: string }) => {
  return (
    <div className="powered-by-feedaura">
      <Logo color={primaryColor} size={18} />
      <span>
        Powered by <span className="feedaura-highlight"style={{color:primaryColor}}>Feedaura</span>
      </span>
    </div>
  );
};

export default PoweredByFeedaura;
